import { moduleType } from "../../../utils/modules";

export function isAlreadySet(array: any, user: string | undefined) {
  return array && Array.isArray(array)
    ? array.filter((person: any) => person.userId === user)
    : [];
}

export function otherUsersSettings(array: any, user: string | undefined) {
  return array && Array.isArray(array)
    ? array.filter((person: any) => person.userId !== user)
    : [];
}

export function getUserValue(
  array: any,
  user: string | undefined,
  module: moduleType,
  operationCode: string,
  field: string
) {
  const params =
    array && Array.isArray(array)
      ? array.filter(
          (person: any) =>
            person.user === user &&
            person.module === module &&
            person.operationCode === operationCode &&
            person.field === field
        )
      : [];
  let value = "";

  if (params.length > 0) value = params[0].value;
  return value;
}
